module.exports = __webpack_public_path__ + "static/media/feature-slideg4.614ec86d.jpg";